// GlobalStyles.jsx
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --body-font-family: 'Inter';
    --heading-font-family: 'Lexend';
    --border-radius-root: 4px;
  }

  h1 {
    font-size: 1.75rem;
    font-weight: 500;
    line-height: 2rem;
    font-family: var(--heading-font-family);
  }

  h2 {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.75rem;
    font-family: var(--heading-font-family);
  }

  h3 {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.5rem;
    font-family: var(--heading-font-family);
  }

  h4 {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.25rem;
    font-family: var(--heading-font-family);
  }

  h5 {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    font-family: var(--heading-font-family);
  }

  p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    font-family: var(--body-font-family);
  }

  /* Add more styles for other elements as needed */
`;

export default GlobalStyles;
